/**
 * Pure envelope builders for the `share_document` confirmation round-trip
 * (IMEM-09, HUB-065, COP-051). The produced JSON string is dispatched verbatim
 * as a follow-up user chat message; the runtime's `tryParseDocShareEnvelope`
 * validates it against `DocShareEnvelopeSchema`
 * (`packages/shared/src/schemas/documents.ts`) and the confirm handler resolves
 * the recorded pending suggestion before writing.
 *
 * BINDING: the confirm/dismiss envelopes carry ONLY the `suggestionId` — the
 * server holds the whole binding (documentId, op, scope|targets) in its
 * in-process pending-suggestion store, so nothing consequential is echoed from
 * the client. The card must never re-derive or send the document / scope /
 * targets.
 */
/** `{ kind: 'doc_share_confirm', suggestionId }` as JSON. */
export function buildDocShareConfirmEnvelope(suggestionId) {
    return JSON.stringify({
        kind: 'doc_share_confirm',
        suggestionId,
    });
}
/** `{ kind: 'doc_share_dismiss', suggestionId }` as JSON. */
export function buildDocShareDismissEnvelope(suggestionId) {
    return JSON.stringify({
        kind: 'doc_share_dismiss',
        suggestionId,
    });
}
//# sourceMappingURL=doc-share-envelope.js.map